/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable import/first */
/* eslint-disable no-unused-expressions */
import React, {useState} from "react"

import _ from 'lodash';

import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { ApolloConsumer, gql, useApolloClient } from '@apollo/client';
import {
    Chip,
    Avatar,
    makeStyles,
    IconButton,
    Grid,
    Button,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    MenuItem,
    ListItemIcon,
    ListItemText, Icon,
} from '@material-ui/core'

import Popover from '@material-ui/core/Popover';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import MailIcon from '@material-ui/icons/Mail';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import ThumbUpIcon from '@material-ui/icons/ThumbUp'

import {
  AutorenewOutlined,
  CheckCircleOutline,
  HighlightOffOutlined,
  ScheduleOutlined,
  AddCircleOutline,
  RemoveCircleOutline,
  ErrorOutline,
  UpdateOutlined,
  Loupe as LoupeIcon,
} from '@material-ui/icons';

import InfoTwoToneIcon from '@material-ui/icons/InfoTwoTone';
import WarningTwoToneIcon from '@material-ui/icons/WarningTwoTone';
import SearchTwoToneIcon from '@material-ui/icons/SearchTwoTone';
import DeleteIcon from '@material-ui/icons/Delete'

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import TableManager from "./TableManager";
import FormManager from "./FormManager";
import PopupContent from "./TableComponents/Popups/PopupContent";
import { inactiveSVG , activeSVG, nullSVG } from "./TableComponents/Icons/StatusSVGs"
import { thousandSeparator } from '../../utils/tools'
import { ButtonTooltip } from "../Tooltips/BPMTooltips";
import PopUpData from "./TableComponents/Popups/Popup"
import InvoicePaymentGroupPopUp from "../../pages/Invoice/InvoicePayment/InvoiceGroupPopUp"
import EditIcon from '@material-ui/icons/Edit'
import {Link} from 'react-router-dom'
import {ExportFooterItemCreator, MassiveUploadFooterItemCreator} from "./TableFooterItems"
import BPMDialog from "./TableComponents/Dialogs/BPMDialog";
import HistoryIcon from "@material-ui/icons/History";
import {RawTableQueryBuilder} from "./TableQueryBuilder/RawTableQueryBuilder";
import {DirectTableQueryBuilder} from "./TableQueryBuilder/DirectTableQueryBuilder";
import {RawUnitQueryBuilder} from "./TableQueryBuilder/RawUnitQueryBuilder";
import {DirectUnitQueryBuilder} from "./TableQueryBuilder/DirectUnitQueryBuilder";
import {parsePlainDate, formatDateTime, formatPlainDateDisplay} from '../../utils/DateUtils';


class FormCreator{

    constructor(formCreatorId, name, queries, onConfirmFormStrategy, onCancelFormStrategy){
        this.formCreatorId = formCreatorId;
        this.formName = name;
        this.unitQueryBuilder = queries.unitQueryBuilder || (queries.unitQuery ? new RawUnitQueryBuilder(queries.unitQuery) : new DirectUnitQueryBuilder(name));
        this.newMutator = queries.newMutator;
        this.editMutator = queries.editMutator;
        this.onConfirmFormStrategy  = onConfirmFormStrategy || new DefaultFormConfirmStrategy();
        this.onCancelFormStrategy  = onCancelFormStrategy || new DefaultFormCancelStrategy();
        this._inputs = [];
    }

    setOnConfirmFormStrategy  = strat => {
        this.onConfirmFormStrategy = strat
    }
    setOnCancelFormStrategy  = strat => {
        this.onCancelFormStrategy = strat
    }


    addInputs(inputs){
        this._inputs = this._inputs.concat(inputs);
    }

    getQueryName(query){
        return query ? query.split('{')[0].split('(')[0].trim() : false;
    }

    set inputs(inputs){
        this._inputs = inputs;
    }

    create = () =>{
        return new FormManager(
            this.formCreatorId,
            this.formName,
            this.unitQueryBuilder,
            this.newMutator,
            this.editMutator,
            this._inputs,
            this.onConfirmFormStrategy,
            this.onCancelFormStrategy,
        )
    }
}

class DefaultTranslationsStrategy{
    translate = (label,t) => {
        return (t('fieldLabels:'+label))
    }
}

function HistoryButtonComponent(props){
    return(
        <>
            <Link to={`edit/${props.data.id}`}>
                <IconButton size="medium" style={{padding: 0}}>
                    <HistoryIcon />
                </IconButton>
            </Link>
        </>
    )
}

class DefaultHistoryButtonStrategy{
    createWith = (data, ctx) =>{
        if (ctx && ctx.readOnly) return null;
        return <HistoryButtonComponent data={data} />
    }
}

function EditButtonComponent(props){
    return(
        <>
            { props.editButtonDisplay ?
                <Link to={`edit/${props.data.id}`}>
                    <IconButton size="medium" style={{padding: 0}}>
                        <EditIcon />
                    </IconButton>
                </Link>
            :
                null
            }
        </>
    )
}


class DefaultEditButtonStrategy {
  createWith = (data, ctx) => {
        return <EditButtonComponent editButtonDisplay={ctx.editButtonDisplay} data={data} />
    }
}

function BayphoneNextStatusButtonComponent(props){
    return(
        <>
            { props.editButtonDisplay ?
                <Link to={`edit/${props.data.id}`}>
                    <IconButton size="medium" style={{padding: 0}}>
                        <SkipNextIcon />
                    </IconButton>
                </Link>
            :
                null
            }
        </>
    )
}

class BayphoneEditButtonStrategy{
    createWith = (editButtonDisplay, data) =>{
        return <BayphoneNextStatusButtonComponent editButtonDisplay={editButtonDisplay} data={data} />
    }
}
//
// ActionButtonsStrategy

function LinkButtonComponent(props){
    return (
        <>
            <Link to={props.to}>
                <IconButton size={props.size || "medium"} style={{padding: 0}}>
                    <Icon>{props.iconName || 'playArrow'}</Icon>
                </IconButton>
            </Link>
        </>
    )
}

// Base interfaces for strategies (declarative signatures)
class BaseDisplayStrategy {
    // enforce doFor(enhanceTable)
    doFor(_enhanceTable) { throw new Error('Not implemented') }
}

class BaseRowActionButtonCreator {
    // enforce createWith(rowData, ctx)
    // implementations should also expose an actionId when applicable
    actionId = undefined
    createWith(_rowData, _ctx) { throw new Error('Not implemented') }
}

class BaseRowActionButtonsContainerCreator {
    // enforce createWith(actionButtonsConfig, rowData, ctx)
    createWith(_config, _rowData, _ctx) { throw new Error('Not implemented') }
}

class BaseSelectedRowsActionsStrategy {
    // enforce doFor(props)
    doFor(_props) { throw new Error('Not implemented') }
}

// Default edit action using the same icon and route as the legacy Edit button
class DefaultEditRowActionButtonCreator extends BaseRowActionButtonCreator {
    constructor(){
        super();
        this.size = 'medium'
        this.actionId = 'edit'
    }
    createWith = (rowData, ctx) => {
        if (ctx && ctx.readOnly) return null;
        return (
            <Link to={`edit/${rowData.id}`}>
                <IconButton size={this.size} style={{padding: 0}}>
                    <EditIcon />
                </IconButton>
            </Link>
        )
    }
}

function PopupButtonComponent(props){
    return (
        <>
            <Link to={props.to}>
                <IconButton size={props.size || "medium"} style={{padding: 0}}>
                    <Icon>{props.iconName || 'playArrow'}</Icon>
                </IconButton>
            </Link>
        </>
    )
}

class DefaultRowActionLinkButtonCreator extends BaseRowActionButtonCreator{
    constructor(actionId = 'edit', actionUrl = 'edit/{rowDataId}', iconName = null){
        super();
        this.actionId = actionId;
        this.actionUrl = actionUrl;
        this.iconName = iconName || 'edit';
    }
    createWith = (rowData, ctx) => {
        const url = this.actionUrl.replace('{rowDataId}', rowData.id);
        return <LinkButtonComponent to={url} iconName={this.iconName} />
    }
}

class DefaultActionButtonsContainerCreator extends BaseRowActionButtonsContainerCreator{
    createWith = (rowActionButtonCreators, rowData, ctx) => {
        if(!rowActionButtonCreators || rowActionButtonCreators.length === 0) return null;
        return (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                { rowActionButtonCreators.map((buttonCreator, idx) => (
                    <React.Fragment key={`row_action_${idx}`}>
                        {/* Creator pattern call — Row action button creator family (BaseRowActionButtonCreator): createWith(rowData, ctx). */}
                        { buttonCreator.createWith(rowData, ctx)}
                    </React.Fragment>
                ))}
            </div>
        )
    }
}

//

class TableCreator{
    constructor(tableCreatorId, tableName, queries, onClickStrategy, displayStrategy, popupContentStrategy){
        this.tableCreatorId = tableCreatorId;
        this.tableName = tableName;
        // this.tableQuery = queries.tableQuery;
        this.tableQueryBuilder = queries.tableQueryBuilder || (queries.tableQuery ? new RawTableQueryBuilder(queries.tableQuery) : new DirectTableQueryBuilder(tableName));
        // this.unitQuery = queries.unitQuery;
        this.unitQueryBuilder = queries.unitQueryBuilder || (queries.unitQuery ? new RawUnitQueryBuilder(queries.unitQuery) : new DirectUnitQueryBuilder(tableName));
        this.deleteMutator = queries.deleteMutator;
        this.onClickStrategy = onClickStrategy  || new DefaultClickStrategy();
        this.displayStrategy = displayStrategy || new DefaultDisplayStrategy();
        this.popupContentStrategy = popupContentStrategy || new DefaultPopupContentDisplayStrategy();
        this.selectedRowActionsStrategy = new DefaultSelectedRowsActionsStrategy();
        this.tableTranslation = new DefaultTranslationsStrategy();
        this.massiveUploadName = tableName;
        this.massiveUploadTemplateUrlContext = undefined;
        this._descriptions = [];
        this.variables = [];
        this.tableMapper = new DefaultTableNodeDataGetter();
        this.additionalFilters = {};
        this.initialFilters = {};
        this.tableObjectMapper = new DefaultObjectNodeGetter();
        this.tableFooterItems = [new ExportFooterItemCreator(), new MassiveUploadFooterItemCreator()];
        this.tableFooterDialogs = [];
        this.tableCreatorCreatorParentProps = null;
        this.defaultRowHeight = 36.5;
        this.readOnlyRowEvaluator = null
        this.customRowStyleEvaluator = null
        this.customCellStyleEvaluator = null
        this.showPopupInventoryAssociations = false
        this.showPopupChangeHistoryPanel = true
        this.totalsRowConfig = null
        // Row action buttons container and button creators
        this.rowActionButtonsContainerCreator = new DefaultActionButtonsContainerCreator();
        this.rowActionButtonCreators = [new DefaultEditRowActionButtonCreator()];
    }

    setTableCreatorCreatorParentProps = tableCreatorCreatorParentProps => {
        this.tableCreatorCreatorParentProps = tableCreatorCreatorParentProps
    }

    setCustomTableMapper = mapper => {
        this.tableMapper = mapper
    }

    setTableQuery = query => {
        this.tableQuery = query
    }

    setMassiveUploadTemplateUrlContext = urlContext => {
        this.massiveUploadTemplateUrlContext  = urlContext;
    }

    setSelectedRowActionsStrategy = strategy => {
        this.selectedRowActionsStrategy = strategy;
    }

    addDescriptions(description){
        this._descriptions = this._descriptions.concat(description);
    }

    setInitialSortField = (fieldName, direction) => {
        this.initialSortFieldName = fieldName;
        this.initialSortFieldDirection = direction;
    }

    setDisplayStrategy = strategy => {
        this.displayStrategy = strategy;
    }
    setPopupContentStrategy = (strategy) => {
        this.popupContentStrategy = strategy;
    }
    setOnClickStrategy = (strategy) => {
        this.onClickStrategy = strategy;
    }

    setDescriptions(descriptions){
        this._descriptions = descriptions;
    }
    setVariables(variables){
        this.variables = variables;
    }

    setAdditionalFilters(filters) {
        this.additionalFilters = {...filters};
    }

    setInitialFilters(filters) {
        this.initialFilters = {...filters};
    }

    addRowActionButtonCreator = (actionButtonCreator) => {
      this.rowActionButtonCreators.push(actionButtonCreator);
    }

    setTableFooterItems = tableFooterItemObjects => {
        this.tableFooterItems = tableFooterItemObjects
    }

    setTableFooterDialogs = tableFooterDialogs => {
        this.tableFooterDialogs = tableFooterDialogs
    }

    setShowPopupInventoryAssociations (visible) {
        this.showPopupInventoryAssociations = visible
    }

    setShowPopupChangeHistoryPanel (visible) {
        this.showPopupChangeHistoryPanel = visible
    }

    addTableFooterItems = tableFooterItemObjects => {
        this.tableFooterItems = [...this.tableFooterItems, ...tableFooterItemObjects]
    }

    setDefaultRowHeight = rowHeight => {
        this.defaultRowHeight = rowHeight;
    }

    setReadOnlyRowEvaluator = (evaluator) => {
        this.readOnlyRowEvaluator = evaluator;
    }

    setCustomRowStyleEvaluator = (evaluator) => {
        this.customRowStyleEvaluator = evaluator;
    }

    setCustomCellStyleEvaluator = (evaluator) => {
        this.customCellStyleEvaluator = evaluator;
    }

    setTotalsRowConfig = (totalsRowConfig) => {
        this.totalsRowConfig = totalsRowConfig;
    }

    setDetailsField = detailsFieldName => {
        this.detailsFieldName = detailsFieldName
    }

    create = (client, dispatch, reducers, stateSelectors) =>{
        return new TableManager(
            this.tableCreatorId,
            this.tableName,
            this.tableQueryBuilder,
            this.deleteMutator,
            this.unitQueryBuilder,
            this.variables,
            this._descriptions,
            this.onClickStrategy,
            this.displayStrategy,
            this.selectedRowActionsStrategy,
            this.popupContentStrategy,
            this.massiveUploadName,
            this.massiveUploadTemplateUrlContext,
            this.tableMapper,
            this.additionalFilters,
            this.initialFilters,
            this.tableTranslation,
            this.initialSortFieldName,
            this.initialSortFieldDirection,
            client,
            this.rowActionButtonsContainerCreator,
            this.rowActionButtonCreators,
            this.tableObjectMapper,
            this.tableFooterItems,
            this.tableFooterDialogs,
            this.tableCreatorCreatorParentProps,
            this.defaultRowHeight,
            this.readOnlyRowEvaluator,
            this.customRowStyleEvaluator,
            this.customCellStyleEvaluator,
            this.showPopupInventoryAssociations,
            this.showPopupChangeHistoryPanel,
            this.totalsRowConfig,
            dispatch,
            reducers,
            stateSelectors
        )
    }
}

class FormSection {
    constructor(name, priority) {
        this.name = name;
        this.priority = priority;
    }
}

class TableColumSection {
    constructor(id, label, translateLabel) {
        this.id = id;
        this.label = label;
        this.translateLabel = translateLabel;
    }
}

class DefaultExcelDisplayCreator{
    getExcelDisplay(header, data){
        const value = i18next.t("fieldLabels:" + header)
        return {[value]: data}
    }

    getOrder(){
        return 0
    }
}


class ManagerExcelDisplayCreator extends DefaultExcelDisplayCreator{

    getExcelDisplay(header, data) {
        let display = {}
        let n = 1
        for(let manager of data) {
            const managerTr = i18next.t("fieldLabels:Manager")
            const codeTr = i18next.t("fieldLabels:Code")
            const nameTr = i18next.t("fieldLabels:Full Name")

            display[`${managerTr} ${n} ${codeTr}`] = manager.enterpriseId
            display[`${managerTr} ${n} ${nameTr}`] = `${manager.firstName} ${manager.lastName}`

            n = n + 1
        }
        return display
    }
}


class BooleanExcelDisplayCreator extends DefaultExcelDisplayCreator{
    constructor(labelTrue="Active", labelFalse="Inactive") {
        super();
        this.labelTrue=labelTrue;
        this.labelFalse=labelFalse;
    }

    getExcelDisplay(header, data) {
        const labelTrueTr = i18next.t("stateFilter:"+this.labelTrue);
        const labelFalseTr = i18next.t("stateFilter:"+this.labelFalse);

        return {[header]: String(data) == 'true' ? labelTrueTr : labelFalseTr};
    }
}

class StateExcelDisplayCreator extends DefaultExcelDisplayCreator{
    constructor(stateList) {
        super()
        this.stateList = stateList
    }

    getExcelDisplay(header, data) {
        const status = data ? this.stateList[data] : '';
        return {[header]: status ? i18next.t("stateFilter:"+status) : ''};
    }
}



class GeneralExcelDisplayCreator extends DefaultExcelDisplayCreator{
    constructor(label, fields, order=1){
        super()
        this.label = label;
        this.fields = fields;
        this.order = order;
    }

    getExcelDisplay(header, data) {
        let display = {}
        let n = 1
        const labelTr = i18next.t("stateFilter:"+this.label);
        for(let item of data) {
            if(item){
                for (let field of this.fields) {
                    const fieldLabelTr = i18next.t("stateFilter:"+field.label);
                    display[`${labelTr} ${n} ${fieldLabelTr}`] = _.get(item, field.path, field.defaultValue || '')
                }
            }
            n = n + 1
        }
        return display
    }

    getOrder(){
        return this.order
    }
}

class DateTimeDisplayCreator extends DefaultExcelDisplayCreator{
    
    getExcelDisplay(header, data) {
        if (data) {
      // Use formatDateTime or return a Date object if Excel needs it.
      // Assuming Excel export handles Date objects or strings.
      // If we return a Date object, we should ensure it's the correct instant.
      // But for simplicity and consistency with new Utils, let's return the formatted string or a Date object parsed correctly.
      // The original code returned a Date object.
      // Let's use DateUtils to parse it safely.
      // If data is ISO string, new Date(data) is correct for DateTime (UTC).
      const date = new Date(data);
            return {[header]: date};
        } else {
            return {[header]: ''};
        }
    }
}

class DateDisplayCreator extends DefaultExcelDisplayCreator{
    getExcelDisplay(header, data) {
        if (data) {
      // Use parsePlainDate to get a Local Date object at midnight
      const date = parsePlainDate(data.split('T')[0]);
      // 48 secs are added due to a bug in sheetJs (preserving this hack if needed, but applying to the safe date)
      if (date) {
        date.setSeconds(48);
            return {[header]: date};
      }
      return { [header]: '' };
        } else {
            return {[header]: ''};
        }
    }
}

class TableFieldDescription {
    constructor(id, tableMapper, inputDescription, optionals={}){
        this.id = id ;
        this.tableMapper = tableMapper;
        this.popupMapper = optionals['popupMapper'] || this.tableMapper;
        this.inputDescription = inputDescription;
        this.label = optionals['label'];
        this.onlyForm = optionals['onlyForm'] || false;
        this.formatDisplay = optionals['formatDisplay '] || this.defaultNullFunction ;
        this.getChildren = optionals['getChildren'] || this.defaultNullFunction ;
        this.queryName = this.getQueryName(this.queryAllDropdownOptions);
        this.transformer = optionals['transform'] || new DataTransformer();
        this.excelTransformer = optionals['excelTransform'] || this.transformer;
        this.excelDisplay = optionals['excelDisplay'] || new DefaultExcelDisplayCreator();
        this.componentCreator = optionals['componentCreator'] || new DefaultComponentCreator();
        this.orderIdentifier = optionals['orderIdentifier'] || this.id;
        this.hideSort = optionals['hideSort'] || false;
        this.draggable = Boolean(optionals['draggable']);
        this.section = optionals['section'] || null;
        this.translateLabel = optionals['translateLabel']===undefined || optionals['translateLabel'];
        this.hidenField = optionals['hidenField'] || false;
        this.rowFontWeight = optionals['rowFontWeight'] || null;
        this.showInExcelExport = optionals['showInExcelExport']===undefined || optionals['showInExcelExport'];
        this.totalsSettings = optionals['totalsSettings'] || null;
        this.fieldAlign = optionals['fieldAlign'] || 'left';
    }

    getVisibility = (fieldsConfig) => {
        const field = fieldsConfig ? fieldsConfig.find(c => c.id === this.id) : null
        return this.getFieldVisibility(field)
    }

    getFieldVisibility = (field) => {
        return !this.hidenField && (field ? !field.visibility : !this.onlyForm)
    }

    getQueryName(query){
        return query ? query.split('{')[0].split('(')[0].trim() : false;
    }

    set visibility(visibility){
        this.onlyForm = visibility;
    }

    mapTableData = (data) => {
        return this.tableMapper.mapWith(data);
    }

    defaultNullFunction = (data) => data;

    transform = (data) => {
        return this.transformer.transform(data)
    }

    excelTransform = (data) => {
        return {
            rowData: this.excelDisplay.getExcelDisplay(this.label, this.excelTransformer.excelDataProcessor(data)), 
            order: this.excelDisplay.getOrder()
        }
    }

    getLabel = (tableTranslation, t) => {
        if (this.translateLabel && this.label) {
            return tableTranslation.translate(this.label, t)
        }

        return this.label;
    }
}

function defaultPrepareData(data) {
    if (
        Array.isArray(data) ||
        typeof(data) == 'boolean' ||
        typeof(data) == 'string' ||
        data === null ){
        return data;
    }else if(typeof(data) == "object" && data.id){
        return data.id;
    }else if(typeof(data) == "object"){
        return data;
    }
}



class FormFieldDescription{
    constructor(id,inputDescription, section, priorityOnSection, optionals={}){
        this.id = id;
        this.inputDescription = inputDescription;
        this.label = optionals['label'] ;
        this.formatDisplay = optionals['formatDisplay '] || this.defaultNullFunction ;
        this.getChildren = optionals['getChildren'] || this.defaultNullFunction ;
        this.required = optionals['required'] || false;
        this.creationReadOnly = optionals['readOnly'] || optionals['creationReadOnly'] || false;
        this.modificationReadOnly = optionals['readOnly'] || optionals['modificationReadOnly'] || false;
        this.queryAllDropdownOptions = optionals['queryAllDropdownOptions'] || false;
        this.dropdownCustomOptions = optionals['dropdownCustomOptions'] || false;
        this.queryName = this.getQueryName(this.queryAllDropdownOptions);
        this.transformer = optionals['transform'] || new DataTransformer();
        this.excelTransformer = optionals['excelTransform'] || this.transformer;
        this.section = section;
        this.priorityOnSection = priorityOnSection;
        this.dataMapper = optionals['dataMapper'] || (data => data[this.id]);
        this.prepareData = optionals['prepareData'] || defaultPrepareData;
    }

    getQueryName(query){
        return query ? query.split('{')[0].split('(')[0].trim() : false;
    }

    defaultNullFunction = (data) => data;

    transform = (data) => {
        return this.transformer.transform(data)
    }

    mapData = (data) => {
        const value = this.dataMapper(data);
        return value !== undefined && value !== null ? value : this.inputDescription.getDefaultValue();
    }

    prepareData = data => {
        return this.prepareData(data)
    }

    stateTransformer = data => {
        if (data == null){
            return null
        }
        return this.transformer.stateTransformer(data)
    }

    excelTransform = (data) => {
        return this.excelTransformer.excelDataProcessor(data)
    }
}

class DataMapper{
    constructor(path){
        const args = Array.prototype.slice.call(arguments);
        this.mapperPaths = args.map(path => path.split("."));
    }
    mapWith = (data) =>{
        const res = {};
        this.mapperPaths.map(path =>{
            let _data = { ...data };
            path.map(key => _data = _data?.[key] ?? "" );
            res[path[path.length - 1]] = _data
        })
        return res;
    }
}

const DefaultComponent = props => {
    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign}}>
            <span style={{whiteSpace: 'nowrap'}}>
                {props.value}
            </span>
        </div>
    )
}

class DefaultComponentCreator {
    constructor(mapper){
        this.mapper = mapper || null
    }
    createWith(data, rowData, fieldAlign) {
        return (
            <DefaultComponent value={this.mapper ? this.mapper(data) : data} fieldAlign={fieldAlign} />
        )
    }
}

class MultilineComponentCreator extends DefaultComponentCreator {
    createWith(data, rowData, fieldAlign) {
        return (
            <div style={{ 
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                textAlign: fieldAlign 
            }}>
                {data}
            </div>
        );
    }
}

const NumberComponent = props => {
    const value = Number(props.value);
    const precision = props.precision ? props.precision : 0;
    const sufix = props.sufix ? " " + props.sufix : '';
    const style = props.style ? props.style: { width: "100%", textAlign: props.fieldAlign, whiteSpace: "nowrap", overflow: "hidden"};

    return (
        <div style={style}>
          <span>
              {`${props.currencySymbol} ${thousandSeparator(value, precision)}${sufix}`}
          </span>
        </div>
    )
}

class NumberComponentCreator extends DefaultComponentCreator {
    constructor(currencySymbol, precision, sufix) {
        super()
        this.currencySymbol = currencySymbol || "";
        this.sufix = sufix || "";
        this.precision = precision || 0;
    }

    createWith(data, rowData, fieldAlign) {
        const symbol = data?.symbol ? data.symbol : this.currencySymbol
        const value = data?.value ? data.value : data
        return (
            <NumberComponent currencySymbol={symbol} sufix={this.sufix} precision={this.precision} value={value} fieldAlign={fieldAlign} />
        )
    }

}

class BudgetPeriodComponentCreator extends NumberComponentCreator {
    constructor(currencySymbol, index, precision) {
        super(currencySymbol, precision, '')
        this.index = index;
    }

    createWith(data, rowData, fieldAlign) {
        const value = (data?.length > this.index) ? data[this.index].cost : 0
        return (
            <NumberComponent 
                currencySymbol={this.currencySymbol} 
                sufix={this.sufix} 
                precision={this.precision} 
                value={value}
                fieldAlign={fieldAlign}
            />
        )
    }

}

const NumberIconedComponent = props => {
    const value = Number(props.value);
    const precision = props.precision ? props.precision : 0;
    return (
        <div style={{width: "100%", textAlign: props.fieldAlign}}>
            {props.currencySymbol + thousandSeparator(value, precision)}
            {(props.buttonType?.type === "warnUnValidatedsIcon") ?
                <ButtonTooltip title={props.buttonType?.caption}>
                    <InfoTwoToneIcon style={{ color: '#E67E22', fontSize: '16px' }}/>
                </ButtonTooltip>
            :
                (props.buttonType?.type === "warnInvoicesIcon") ?
                    <ButtonTooltip title={props.buttonType?.caption}>
                        <WarningTwoToneIcon style={{ color: '#FE0000', fontSize: '16px' }}/>
                    </ButtonTooltip>
                :
                <></>
            }
        </div>
    )
}

class NumberIconedComponentCreator extends DefaultComponentCreator {
    constructor(precision) {
        super()
        this.precision = precision || 0;
    }

    createWith(data, rowData, fieldAlign) {
        return (
            <NumberIconedComponent currencySymbol={data.symbol} precision={this.precision} buttonType={data.buttonType} value={data.value} fieldAlign={fieldAlign} />
        )
    }

}

const NumberLinkIconComponent = props => {
    const value = Number(props.value);
    const id = props.id;
    const precision = props.precision ? props.precision : 0;
    const link = props.link ? props.link : '';
    const { t } = useTranslation()
    const toolTipLabel = props.toolTipLabel ? t(props.toolTipLabel) : ''

    return (
        <div style={{width: "100%", textAlign: props.fieldAlign}}>
            <span style={{whiteSpace: 'nowrap', paddingRight: '5px'}}>
                {`${props.currencySymbol ? props.currencySymbol+' ' : ''}${thousandSeparator(value, precision)}${props.sufix ? ' ' +props.sufix : ''}`}
            </span>
            <Link to={`${link}${id}`}>
                <ButtonTooltip title={toolTipLabel}>
                    <LoupeIcon style={{ color:'0A1F2E', fontSize:'22px' }}/>
                </ButtonTooltip>
            </Link>
        </div>
    )
}

class NumberLinkIconComponentCreator extends DefaultComponentCreator {
    constructor(precision, link, label, sufix) {
        super()
        this.sufix = sufix || "";
        this.precision = precision || 0;
        this.link = link || "";
        this.label = label || "";
    }

    createWith(data, rowData, fieldAlign) {
        return (
            <NumberLinkIconComponent 
                currencySymbol={data.symbol} 
                precision={this.precision} 
                value={data.value} 
                id={data.id} 
                link={this.link}
                toolTipLabel={this.label}
                sufix={this.sufix}
                fieldAlign={fieldAlign} />
        )
    }

}

const PasswordComponent = props => {
    const [showPassword, setShowPassword] = useState(false);
    const yPos = '50%';

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign }}>
            <IconButton
                onClick={event => {
                    event.stopPropagation()
                    handleClickShowPassword()

                }}
                edge="end"
            >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
            <span style={{ marginLeft: 15, whiteSpace: 'nowrap'}}>
                { showPassword ? props.value : "***********"}
            </span>
        </div>
    )
}

class PasswordComponentCreator extends DefaultComponentCreator {
    constructor() {
        super()
    }

    createWith(data, rowData, fieldAlign) {
        return (
            <PasswordComponent value={data} fieldAlign={fieldAlign} />
        )
    }

}

const StateComponent = props => {
    const { t } = useTranslation()

    const getTranslatedState = () => {
        return t("stateFilter:"+props.value)
    }

    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign }}>
            <span style={{whiteSpace: 'nowrap'}}>
                {props.value ? getTranslatedState() : ''}
            </span>
        </div>
    )
}

class StateComponentCreator extends DefaultComponentCreator {
    constructor(stateList) {
        super()
        this.stateList = stateList
    }

    createWith(data, rowData, fieldAlign) {
        return (
            <StateComponent value={data ? this.stateList[data] : ''} fieldAlign={fieldAlign} />
        )
    }
}

const chipUseStyles = makeStyles(theme => (
    {
        chip: {
            '&.MuiChip-root': {
                height: 32,
            }
        }
    })
);

function CustomChip(props) {
    const { label, ptc, color, translate} = props;
    const { t} = useTranslation()
    const classes = chipUseStyles();

    return(
        <div>
            <Chip
                className={classes.chip}
                style={{margin:2}}
                color={color}
                size={'medium'}
                variant='outlined'
                avatar={ptc ? 
                    <Avatar
                        style={{fontSize: 12, height: '24px', minWidth: '18px', width: 'auto', display: 'flex', justifyContent: 'center', padding: '0 4px'}}>{`${ptc}%`}</Avatar>:null}
                label={translate ? t(label) : label}
            />
        </div>
    )
}


const composedChipStyle = {
    margin:2,
    backgroundColor:'#075e54',
    "&:hover": {
        backgroundColor: "#a7cbc7"
    }
};

function ComposedChips (props) {
    function handleOpenPopper(event){
        event.stopPropagation()
        setAnchorIcon(event.target)
    }
    function handleClosePopper(event){
        event.stopPropagation()
        setAnchorIcon(null)
    }
    const [anchorIcon, setAnchorIcon] = useState(null)
    const { chips, label } = props;
    const { t } = useTranslation();
    const color = !props.customStyle ? {color:"primary"} : null
    const customStyle = props.customStyle ? props.customStyle : null

    return(
        <div>
            <Chip
                style={props.label ? customStyle : composedChipStyle}
                size='small'
                {...color}
                onClick={handleOpenPopper}
                label={props.label ? props.label: t('Multiple Association')}
            />
            <Popover  open={Boolean(anchorIcon)}
                        onClick={handleClosePopper}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handleClosePopper}
                        disableRestoreFocus
                        anchorEl={anchorIcon}>
                <div style={{padding:20}}>
                    {chips}
                </div>
            </Popover>
        </div>
    )
}

const generateKey = (pre) => {
    return `${ pre }_${ new Date().getTime() }`;
}

const ChipsComponent = props => {
    const { data, mappers, showPercentage, associationDisplayNameResolver, nullAssociationDisplayName } = props;

    const convertDataToStr = (association) => {
        var mappedDataString = " "
        for(let mapper of mappers){
            mappedDataString = String(mappedDataString)+" "+_.get(association, mapper)
        }
        return(mappedDataString)
    }
    const chips = data.filter(a => a).map((a, index) => {
        const associationDisplayName = mappers ? convertDataToStr(a) : associationDisplayNameResolver(a);
        const unassigned = associationDisplayName == nullAssociationDisplayName || associationDisplayName == null;

        return(
            <CustomChip
                label={!unassigned ? associationDisplayName : 'Not Assigned'}
                key={a.id || generateKey('UnassignedAssociation_' + index) + 'chip'}
                color={!unassigned ? 'primary' : 'secondary'}
                ptc={showPercentage ? a.percentage : null}
                translate={unassigned}
            />
        )
    })

    let components;
    if(chips.length < 1){
        components = <CustomChip label={'Not Assigned'} key={'UnassignedAssociation_chip'} color={'secondary'} ptc={showPercentage ? '100' : null} translate={true}/>
    } else if(chips.length < 2 && mappers){
        components = <ComposedChips label={associationDisplayNameResolver(data[0])} chips={chips}/>
    } else if (chips.length < 2){
        components = chips
    } else {
        components = <ComposedChips chips={chips}/>
    }

    return (
        <div style={{overflow: 'hidden'}}>
            {components}
        </div>
    )
}

const LabeledChipsComponent = props => {
    const { data, mappers, showPercentage, associationDisplayNameResolver, nullAssociationDisplayName } = props;

    const convertDataToStr = (association) => {
        var mappedDataString = " "
        for(let mapper of mappers){
            mappedDataString = String(mappedDataString)+" "+_.get(association, mapper)
        }
        return(mappedDataString)
    }

    const chips = data.filter(a => a).map((a, index) => {
        const associationDisplayName = mappers ? convertDataToStr(a) : associationDisplayNameResolver(a);
        const unassigned = associationDisplayName == nullAssociationDisplayName || associationDisplayName == null;

        return(
            <CustomChip
                label={!unassigned ? associationDisplayName : 'Not Assigned'}
                key={a.id || generateKey('UnassignedAssociation_' + index) + 'chip'}
                color={!unassigned ? 'primary' : 'secondary'}
                translate={unassigned}
            />
        )
    })

    let components;
    if(chips.length < 1){
        components = <CustomChip label={'Not Assigned'} key={'UnassignedAssociation_chip'} color={'secondary'} translate={true}/>
    } else if(chips.length < 2 && mappers){
        components = <ComposedChips label={associationDisplayNameResolver(data[0])} chips={chips}/>
    } else if (chips.length < 2){
        components = chips
    } else {
        components = <ComposedChips chips={chips}/>
    }

    return (
        <div style={{overflow: 'hidden'}}>
            {components}
        </div>
    )
}

const ConsolidatedSBOChipsComponent = props => {
    const [associoations] = useState(props.data)

    const chips = associoations.map((a, index) => {
        const associationDisplayName = a
        const unassigned = associationDisplayName == props.nullAssociationDisplayName;
        return(
            <CustomChip
                label={!unassigned ? associationDisplayName : 'Not Assigned'}
                key={a || generateKey('UnassignedAssociation_' + index) + 'chip'}
                color={!unassigned ? 'primary' : 'secondary'}
                translate={true}/>
        )
    })

    let components;
    components = <ComposedChips customStyle={props.customStyle} label={props.associationDisplayNameResolver} chips={chips}/>

    return (
        <div style={{overflow: 'hidden', margin:"2%"}}>
            {components}
        </div>
    )
}

class ConsolidatedSBOChipComponentCreator extends DefaultComponentCreator{
    createWith(data, rowData, fieldAlign) {
        const periodChipStyle = {
            margin:2,
            backgroundColor:"#0a1f2e",
            color:"white",
            "&:hover": {
                backgroundColor: "#a7cbc7"
            }
        };
        const vendorChipStyle = {
            margin:2,
            backgroundColor:"#55758C",
            color:"white",
            "&:hover": {
                backgroundColor: "#a7cbc7"
            }
        };

        return(
            <>
            {data ?
            <Grid container>
                <Grid xs={5} item>
                    <ConsolidatedSBOChipsComponent
                    nullAssociationDisplayName={null}
                    associationDisplayNameResolver={"Vendors"}
                    data={data["vendors"]}
                    customStyle={vendorChipStyle} />
                </Grid>
                <Grid xs={5} item>
                    <ConsolidatedSBOChipsComponent
                    nullAssociationDisplayName={null}
                    associationDisplayNameResolver={"Periods"}
                    data={data["periods"]}
                    customStyle={periodChipStyle} />
                </Grid>
            </Grid>
            : null}
            </>
        )
    }


}

class GeneralChipComponentCreator extends DefaultComponentCreator {
    constructor(mappers,innerMapper, defaultLabel=null, showPercentage=true){
        super()
        this.mappers = mappers
        this.innerMapper = innerMapper
        this.defaultLabel = defaultLabel
        this.showPercentage = showPercentage
    }

    mapperCreator(data){
        let dataStr = ""
        let arrayData = []

        if (Array.isArray(data)) {
            arrayData = data
        } else {
            arrayData = [data]
        }

        for(let item of arrayData){
            for(let mapper of this.mappers){
                if(dataStr  == ""){
                    dataStr = _.get(item, mapper);
                } else {
                    dataStr = dataStr + " - " + _.get(item, mapper)
                }
            }
        }

        if (!dataStr) {
            dataStr = this.defaultLabel
        }

        return dataStr
    }

    createWith(data, rowData, fieldAlign) {
        return(
            <ChipsComponent
                nullAssociationDisplayName={'Not Assigned'}
                associationDisplayNameResolver={(data) => data ? this.mapperCreator(data) : null}
                showPercentage={this.showPercentage && this.innerMapper==null}
                mappers={this.innerMapper}
                data={data||[]}
                value={this.mapperCreator(data)}
                fieldAlign={fieldAlign}
            />
        )
    }
}

class LabeledChipComponentCreator extends DefaultComponentCreator {
    constructor(mappers, labels) {
        super()
        this.mappers = mappers
        this.labels = labels
    }

    mapperCreator(data){
        let dataStr = ""
        let arrayData = []

        if (Array.isArray(data)) {
            arrayData = data
        } else {
            arrayData = [data]
        }

        for(let item of arrayData){
            for(let mapper of this.mappers){
                if(dataStr  == ""){
                    dataStr = _.get(item, mapper);
                } else {
                    dataStr = dataStr + " - " + _.get(item, mapper)
                }
            }
        }

        return dataStr
    }

    createWith(data, rowData, fieldAlign) {
        return(
            <LabeledChipsComponent
                nullAssociationDisplayName={'Not Assigned'}
                labels={this.labels}
                associationDisplayNameResolver={(data) => data ? this.mapperCreator(data) : null}
                data={data||[]}
                value={this.mapperCreator(data)}
                fieldAlign={fieldAlign}
            />
        )
    }
}

const StatusChipComponent = props => {
    const getStateProperty = () => {
        const stateProperties = {
            'FINISHED': {color: 'green', icon: <CheckCircleOutline style={{color: 'green'}}/>},
            'ERROR': {color: 'red', icon: <HighlightOffOutlined style={{color: 'red'}}/>},
            'FAILED': {color: 'red', icon: <HighlightOffOutlined style={{color: 'red'}}/>},
            'IN_PROCESS': {color: 'black', icon: <AutorenewOutlined style={{color: 'black'}}/>},
            'NOT_STARTED': {color: 'grey', icon: <ScheduleOutlined style={{color: 'grey'}}/>},
            'NEED_REPROCESS': {color: 'orange', icon: <CheckCircleOutline style={{color: 'orange'}}/>},
            'PENDING': {color: 'grey', icon: <ScheduleOutlined style={{color: 'grey'}}/>},
            'PROCESSING': {color: 'black', icon: <AutorenewOutlined style={{color: 'black'}}/>},
            'COMPLETED': {color: 'green', icon: <CheckCircleOutline style={{color: 'green'}}/>},
            'ROLLED_BACK': {color: 'green', icon: <CheckCircleOutline style={{color: 'green'}}/>},
            'ROLLING_BACK': {color: 'black', icon: <AutorenewOutlined style={{color: 'black'}}/>},
            'ROLLBACK_FAILED': {color: 'red', icon: <HighlightOffOutlined style={{color: 'red'}}/>},
            'PUBLISH': {color: 'green', icon: <CheckCircleOutline style={{color: 'green'}}/>},
            'UNPUBLISH': {color: 'grey', icon: <ScheduleOutlined style={{color: 'grey'}}/>},
        };

        return stateProperties[props.value] || {icon: null}
    }

    return(
        <>
            {(props.value && props.value != 'NULL') ?
                <Chip
                    variant="outlined"
                    icon={getStateProperty().icon}
                    size="small"
                    label={props.value}
                    style={{color: getStateProperty().color, border: getStateProperty().color, borderStyle: 'solid', borderWidth: '1px'}}
                />
            : null}
        </>
    )
}

class StatusChipComponentCreator extends DefaultComponentCreator {
    createWith(data, rowData, fieldAlign) {
        return(
            <StatusChipComponent value={data} fieldAlign={fieldAlign} />
        )
    }
}

class PeriodSubProcessStateChipComponentCreator extends DefaultComponentCreator {
    constructor(states) {
        super()
        this.states = states
    }

    getStateLabel = (state) => {
        return this.states[state] ? this.states[state].toUpperCase() : state
    }

    createWith(data){
        return(
            <StatusChipComponent value={this.getStateLabel(data)} />
        )
    }
}

class CMActionChipComponent extends React.Component{
    CREATE = 'CREATE'
    UPDATE = 'UPDATE'
    DEACTIVATE = 'DEACTIVATE'
    UNDEFINED = 'UNDEFINED'

    getStateProperty(){
        const stateProperties = {
            'CREATE': {color: 'green', icon: <AddCircleOutline style={{color: 'green'}}/>},
            'UPDATE': {color: 'blue', icon: <AutorenewOutlined style={{color: 'blue'}}/>},
            'DEACTIVATE': {color: 'black', icon: <RemoveCircleOutline style={{color: 'black'}}/>},
            'UNDEFINED': {color: 'grey', icon: <ErrorOutline style={{color: 'grey'}}/>},
        };
    
        return stateProperties[this.props.value] || {icon: null}
    }

    render(){
        return(
            <>
            {this.props.value ?
            <Chip
                variant="outlined"
                icon={this.getStateProperty().icon}
                size="small"
                label={this.props.value}
                style={{color: this.getStateProperty().color, border: this.getStateProperty().color, borderStyle: 'solid', borderWidth: '1px'}}
            />
            : null}
            </>
        )
    }
}

class CMActionChipComponentCreator extends DefaultComponentCreator {
    createWith(data){
        return(
            <CMActionChipComponent value={data} />
        )
    }
}

const TreeNodeComponent = props => {
    const level = props.level || 0

    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>
            <span style={{whiteSpace: 'nowrap', paddingLeft: level*20}}>
                {props.value}
            </span>
        </div>
    )
}

class TreeNodeComponentCreator extends DefaultComponentCreator {
    createWith(data, rowData, fieldAlign) {
        return (
            <TreeNodeComponent value={data?.name ? data.name : null} level={data?.level ? data.level : null} fieldAlign={fieldAlign} />
        )
    }
}


const ProcessControlTasksComponent = props => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation();

    function handleOpen(event){
        event.stopPropagation();
        setOpen(true);
    }

    function handleClose(event){
        event.stopPropagation();
        setOpen(false);
    }

    const paperProps = {style: { 
        with: '80vw',
        height: '60vh',
    }}

    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign }}>
            {(props.tasks.length > 0) ?
            <>
                {props.count + "  "}
                <ButtonTooltip title={t("View Sub-Processes")}>
                    <SearchTwoToneIcon style={{ color:'5F5F5F', fontSize:'22px', cursor:'pointer' }} onClick={handleOpen}/>
                </ButtonTooltip>
            </>
            : props.count}
            <BPMDialog
                open={open}
                maxWidth='lg' 
                onClose={handleClose}
                PaperProps={paperProps}
            >
                {props.popupContent(props.processControlId, handleClose)}
            </BPMDialog>
        </div>
    )
}

class ProcessControlTasksComponentCreator extends DefaultComponentCreator {
    constructor(popupContent){
        super()
        this.popupContent = popupContent;
    }
    createWith(data, rowData, fieldAlign) {
        return(
            <ProcessControlTasksComponent value={data.count} {...data} popupContent={this.popupContent} fieldAlign={fieldAlign} />
        )
    }
}



const StatusComponent = props => {
    const getSVG = () => {
        const value = String(props.value)
        if (value === '' || value === 'null' || value === 'undefined') {
            return nullSVG
        } else {
            return value === "true" ? activeSVG : inactiveSVG
        }
    }

    return(
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign }}>
            { getSVG() }
        </div>
    )
}

class StatusComponentCreator extends DefaultComponentCreator {
    createWith(data, rowData, fieldAlign) {
        return(
            <StatusComponent value={data} fieldAlign={fieldAlign} />
        )
    }
}

const ThousandSeparatorComponent = props => {
    const number = Number(Number(props.value).toFixed(2))

    return(
        <div style={{textAlign: props.fieldAlign}}>
            <span>{thousandSeparator(number,props.digits)}</span>
        </div>
    )
}

class ThousandSeparatorCreator extends DefaultComponentCreator {
    constructor(digits){
        super()
        this.digits = digits || null
    }
    createWith(data, rowData, fieldAlign) {
        return (
            <ThousandSeparatorComponent digits={this.digits} value={data} fieldAlign={fieldAlign} />
        )
    }
}

const DateTimeComponent = props => {
  const formattedDate = props.value
    ? formatDateTime(props.value, 'dd/MM/yyyy HH:mm:ss')
    : '';
    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign }}>
      <span style={{ whiteSpace: 'nowrap' }}>{formattedDate}</span>
        </div>
    )
}

class DateTimeComponentCreator extends DefaultComponentCreator {
    createWith(data, rowData, fieldAlign) {
        return(
            <DateTimeComponent value={data} fieldAlign={fieldAlign} />
        )
    }
}

const DateComponent = props => {
  const formattedDate = formatPlainDateDisplay(props.value);
    return (
        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', textAlign: props.fieldAlign }}>
            <span style={{whiteSpace: 'nowrap'}}>
                {formattedDate}
            </span>
        </div>
    )
}

class DateComponentCreator extends DefaultComponentCreator {
    createWith(data, rowData, fieldAlign) {
        return(
            <DateComponent value={data} fieldAlign={fieldAlign} />
        )
    }
}

class DataTransformer{

    constructor(transformer, stateMapper, defaultTransformerValue=""){
       this.transformerFunction =  transformer || this.defaultNullFunction;
       this.stateMapper = stateMapper || this.formDataProcessor;
       this.defaultTransformerValue = defaultTransformerValue;
    }

    transform = data => {
        if (!data && typeof(data) != "boolean"){
             return this.defaultTransformerValue;
        };
        return this.transformerFunction(data)
    }

    stateTransformer = data => {
        return this.stateMapper(data)
    }

    formDataProcessor = data => {
        if (data && data.id){
            return data.id;
        }
        return data;
    }

    excelDataProcessor = data => {
        if (!data){
            return ''
        }else if(typeof(this.transformerFunction(data)) =="object"){
            return this.transformerFunction(data)
        }else{
            return this.transformerFunction(data)
        }
    }

    defaultNullFunction = (data) => {
        let res =  [];
        Object.values(data).map(str =>{
            res.push(str);
        });
        return res.join(" ")
    };

}

class ClickStrategy {
    shouldShowCursor() {
        return true;
    }

  // Standard signature for all click strategies
  doFor = (_tableWrapper, _data, _rowData) => {}

  createPopUpWith(client,TableObject,clickedId, popupDisplay, handleSetFilters, hidePopup){
  }

}

class NullClickStrategy extends ClickStrategy {
    doFor = (table, data) => {
    }

    shouldShowCursor() {
        return false;
    }

    createPopUpWith(client,TableObject,clickedId, popupDisplay, handleSetFilters, hidePopup){
    }
}

class DefaultClickStrategy extends ClickStrategy {
    doFor = (table, data) => {
        table.showPopupFor(data.id);
    }
    createPopUpWith(client,TableObject,clickedId, popupDisplay, handleSetFilters, hidePopup, classes){
        return React.createElement(PopUpData,{client:client,
            TableObject:TableObject,
            id:clickedId,
            openD:popupDisplay,
            handleSetFilters: handleSetFilters,
            close:hidePopup,
            classes:classes,
            style:{zindez:99999999},
            })
    }
}

class InventoryClickStrategy extends DefaultClickStrategy {
    createPopUpWith(client,TableObject,clickedId, popupDisplay, handleSetFilters, hidePopup, classes){
        return React.createElement(PopUpData,{client:client,
            TableObject:TableObject,
            id:clickedId,
            openD:popupDisplay,
            handleSetFilters: handleSetFilters,
            close:hidePopup,
            classes:classes,
            style:{zindez:99999999},
            })
    }
}

class InvoiceClickStrategy extends ClickStrategy {
    doFor = (table, data) => {
        table.props.history.push("validate/" + data.id)
    }

}


class InvoicePaymentGroupClickStrategy extends ClickStrategy{
    doFor = (table, data) => {
        table.showPopupFor(data.id);
    }
    createPopUpWith(client,TableObject,clickedId, popupDisplay, handleSetFilters, hidePopup, classes){
        return React.createElement(InvoicePaymentGroupPopUp,{client:client,
            TableObject:TableObject,
            id:clickedId,
            openD:popupDisplay,
            handleSetFilters: handleSetFilters,
            close:hidePopup,
            classes:classes,
            style:{zindez:99999999},
            })
    }
}

class DefaultDisplayStrategy extends BaseDisplayStrategy {
    doFor = (table) => {
        return null
    }
}

class HideMassiveUploadsDisplayStrategy extends BaseDisplayStrategy {
    doFor = (table) => {
        table.hideMassiveUploadsButton();
    }
}

class TablePickerClickStrategy extends ClickStrategy{
    constructor( stateHandler ){
        super()
        this.stateHandler = stateHandler;
    }

    doFor = (enhanceTable, data) => {
        this.stateHandler(data);
    }
}

class TableMultiPickerClickStrategy extends ClickStrategy{
    constructor( stateHandler ){
        super()
        this.stateHandler = stateHandler;
    }

    doFor = (enhanceTable, data, objectData) => {
        this.stateHandler(objectData);
    }
}

class TablePickerModelClikStrategy extends ClickStrategy{
    constructor( stateHandler ){
        super()
        this.stateHandler = stateHandler;
    }

    doFor = (enhanceTable, data, objectData) => {
        this.stateHandler(objectData);
    }
}

class DefaultTableNodeDataGetter{
    mapWith(data, mapper){
        const rows = [];
        Object.values(data)[0].edges.map(
            row_data =>{
                row_data = row_data.node;
                rows.push(mapper(row_data))
            }
        )
        return rows;
    }
}

class DefaultObjectNodeGetter{
    mapWith(data, mapper){
        const rows = [];
        Object.values(data)[0].edges.map(
            row_data =>{
                row_data = row_data.node;
                const rowDict = {data:mapper(row_data), objectData: row_data}
                rows.push(rowDict)
            }
        )
        return rows;
    }
}

class CustomTableRowMapperDataGetter{
    constructor(mapper){
        this.mapper = mapper
    }
    mapWith(data, mapper){
        return this.mapper(data, mapper)
    }
}

class TablePickerDisplayStrategy extends BaseDisplayStrategy {
  constructor(props = {}) {
    super();
    this.headerStyles = props.headerStyles || ""
    this.bodyStyles = props.bodyStyles || ""

  }

  doFor = (enhanceTable) => {
    enhanceTable.hideFooter();
    enhanceTable.hideCheckbox();
    enhanceTable.hideAction('edit');
    enhanceTable.setCustomBodyWrapperStyles(this.bodyStyles);
    enhanceTable.setCustomHeaderStyles(this.headerStyles);
  }
}

class TableMultiPickerDisplayStrategy extends BaseDisplayStrategy {
  constructor(props = {}) {
    super();
    this.headerStyles = props.headerStyles || ""
    this.bodyStyles = props.bodyStyles || ""

  }

  doFor = (enhanceTable) => {
    enhanceTable.hideFooter();
    enhanceTable.hideCheckbox();
    enhanceTable.hideAction('edit');
    enhanceTable.setCustomBodyWrapperStyles(this.bodyStyles);
    enhanceTable.setCustomHeaderStyles(this.headerStyles);
  }
}


class InventoryValidationDisplayStrategy extends BaseDisplayStrategy {
  constructor(props = {}) {
        super();
        this.headerStyles = props.headerStyles || ""
        this.bodyStyles = props.bodyStyles || ""

    }
    doFor = (enhanceTable) => {
        enhanceTable.hideAction('edit');
        enhanceTable.hideNewButton();
        enhanceTable.setCustomBodyWrapperStyles(this.bodyStyles);
        enhanceTable.setCustomHeaderStyles(this.headerStyles);
    }
}

class HideDeletionDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideCheckbox();
    }
}

class MassiveUploadsDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideCheckbox();
        enhanceTable.hideAction('edit');
        enhanceTable.hideNewButton();
        enhanceTable.hideFilters();
    }
}

class SimpleTableDisplayStrategy extends BaseDisplayStrategy {
    constructor(hideRefreshButton = false) {
        super();
        this.hideRefreshButton = hideRefreshButton
    }

    doFor = (enhanceTable) => {
        enhanceTable.hideCheckbox();
        enhanceTable.hideAction('edit');
        enhanceTable.hideFooter();
        enhanceTable.hideNewButton();
        enhanceTable.hideFilters();
        enhanceTable.hideLastRowBlank();

        if (this.hideRefreshButton) {
            enhanceTable.hideRefreshButton();
        }
    }
}

class ProcessControlSubProcessesDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideAction('edit');
        enhanceTable.hideFooter();
        enhanceTable.hideNewButton();
        enhanceTable.hideFilters();
        enhanceTable.hideLastRowBlank();
        enhanceTable.hideRefreshButton();
    }
}

class OnlyFilterActionDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideCheckbox();
        enhanceTable.hideAction('edit');
        enhanceTable.hideNewButton();
    }
}

class TableMapperCreator {
    create = () => null;
    addDescriptions = () => null;
}

class InvoiceDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideAction('edit');
        enhanceTable.hideNewButton();
    }
}

class RankingDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideCheckbox();
        enhanceTable.hideAction('edit');
        enhanceTable.hideNewButton();
        enhanceTable.hidePreColumn();
    }
}

class HideEditButtonDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideAction('edit');
    }
}

class HideNewDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideNewButton();
    }
}

class BusgetsDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideCheckbox();
        enhanceTable.hideNewButton();
        enhanceTable.hideFilters();
    }
}

class HideCrudDisplayStrategy extends BaseDisplayStrategy {
    doFor = (enhanceTable) => {
        enhanceTable.hideNewButton();
        enhanceTable.hideCheckbox();
        enhanceTable.hideAction('edit');
    }
}

class AbstractPopupContentDisplayStrategy {
    doFor(props, _tableObject) { throw new Error('Not implemented') };
}

class CustomPopUpContentDisplayStrategy extends AbstractPopupContentDisplayStrategy {
    constructor(component){
        super();
        this.component = component
    }
    doFor(props, _tableObject){
        return React.createElement(this.component,{data:props.data,
                                                   TableObject:_tableObject,
                                                   refetch:props.refetch,
                                                   close:props.close,
                                                   handleSetFilters: props.handleSetFilters
                                                   })
    }

}

class DefaultPopupContentDisplayStrategy extends AbstractPopupContentDisplayStrategy {
  doFor(props, _tableObject) {
        return React.createElement(
            PopupContent, {data:props.data, TableObject:_tableObject}
        )
    }
}

class DefaultFormCancelStrategy{
    doFor(component, path){
        return component.props.history.push(path);
    }
}

class customFormCancelStrategy{
    constructor(strategy){
        this.strategy = strategy
    }
    doFor(formComponent, path){
        return this.strategy()
    }
}

class DefaultFormConfirmStrategy{
    doFor(component, path, response){
        return component.props.history.push(path);
    }
}

class customFormConfirmStrategy{
    constructor(strategy){
        this.strategy = strategy
    }
    doFor(formComponent, path, response){
        return this.strategy(formComponent, path, response)
    }

}

function ToggleSelectedStatusMenuItem(props){
    const { closePopper, changeSelectedState, t } = props

    return (
        <MenuItem
            key={'mnuitem_toggle_status'}
            onClick={
                () => {closePopper(); changeSelectedState()}
            }
        >
            <ListItemIcon>
                <ToggleOffIcon />
            </ListItemIcon>
            <ListItemText primary={t("tableFooter:Toggle Selected Status")}/>
        </MenuItem>
    )
}

function ClearSelectedCheckboxesMenuItem(props){
    const { closePopper, clearAllSelections, t } = props

    return (
        <MenuItem key={'mnuitem_clear_selecteds'} onClick={() => {closePopper(); clearAllSelections() }}>
            <ListItemIcon>
                <CheckBoxOutlineBlankIcon />
            </ListItemIcon>
            <ListItemText primary={t("tableFooter:Clear Selected Checkboxes")} />
        </MenuItem>
    )
}

class DefaultSelectedRowsActionsStrategy extends BaseSelectedRowsActionsStrategy {
  constructor(deleteMutation = null) {
    super();
    this.deleteMutation = deleteMutation;
  }
  doFor({
    closePopper,
    changeSelectedState,
    clearAllSelections,
    ListItemIcon,
    ListItemText,
    MenuItem,
    t,
    selectedRows,
    allRowsSelected,
        filters
    }){
            return (
                <>
                    <ToggleSelectedStatusMenuItem
                        closePopper={closePopper} 
                        changeSelectedState={changeSelectedState}
                        t={t}
                    />

                    <ClearSelectedCheckboxesMenuItem 
                        closePopper={closePopper} 
                        clearAllSelections={clearAllSelections}
                        t={t}
                    />
                </>
            )

    }
}

const VALIDATE_INVOICES = gql `
mutation($ids : [String], $allRecords: Boolean, $filters: String){
  validateInvoices(ids: $ids, allRecords: $allRecords, filters: $filters){
    invoice{
      id
    }
  }
}`;

function InvoiceSelectComponent(props){
    const client = useApolloClient()
    const [message,setMessage]=useState("")
    const [actions,setActions] = useState(false)
    const { closePopper,
            clearAllSelections,
            ListItemIcon,
            ListItemText,
            MenuItem,
            t,
            selectedRows,
            handleErrorMessage,
            handleMessage,
            refreshTable,
            allRowsSelected,
            filters } = props

    const mutateSelectedInvoices =(props)=>{
        let ids = []
        for(let data of props.selectedRows){
            ids.push(data.id)
        }
        client.mutate({
            mutation: props.mutation,
            variables : {ids: ids, allRecords: allRowsSelected, filters: JSON.stringify(filters)}
        }).then(
            res => {
                refreshTable()
                handleMessage("Done");
                closePopper();
            }
        ).catch(
            err =>{
                handleErrorMessage(String(err));
            }
        )
    }

    const handleAction = (mutation) =>{
        clearAllSelections();
        mutateSelectedInvoices({selectedRows:selectedRows, mutation:mutation,closePopper:closePopper,clearAllSelections :clearAllSelections})
        closePopper();
    }

    let invoiceStates = new Set()
    for(let invoiceData of selectedRows){
        invoiceStates.add(invoiceData.state)
    }

    if((allRowsSelected || invoiceStates.size == 1) && !actions){
        if(!invoiceStates.has("VALIDATED")){
            setActions("validate")
        }
    }

    return (
        <>
            <ClearSelectedCheckboxesMenuItem 
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />

            {actions == "validate" ? <MenuItem onClick={() =>handleAction(VALIDATE_INVOICES)}>
                <ListItemIcon>
                    <DoneIcon />
                </ListItemIcon>
                <ListItemText primary={t("tableFooter:Validate Selected Invoices")} />
            </MenuItem>
            : null }
        </>
    )


}

class InvoiceSelectedActions extends BaseSelectedRowsActionsStrategy {
  doFor({
    closePopper,
    changeSelectedState,
    clearAllSelections,
    ListItemIcon,
    ListItemText,
    MenuItem,
    t,
    selectedRows,
    allRowsSelected,
    filters,
    handleSetFilters,
    handleMessage,
    handleErrorMessage,
        refreshTable
    }){
        return (
            <InvoiceSelectComponent
                closePopper={closePopper}
                clearAllSelections={clearAllSelections}
                ListItemIcon={ListItemIcon}
                ListItemText={ListItemText}
                MenuItem={MenuItem}
                t={t}
                selectedRows={selectedRows}
                allRowsSelected = {allRowsSelected}
                filters={filters}
                handleMessage={handleMessage}
                handleErrorMessage={handleErrorMessage}
                refreshTable={refreshTable}
            />
        )

    }
}

class ValidateSelectedInventoriesStrategy{
    constructor(validateHandler){
        this.validateHandler = validateHandler;
    }
    doFor({
        closePopper,
        changeSelectedState,
        clearAllSelections,
        ListItemIcon,
        ListItemText,
        MenuItem,
        t,
        selectedRows,
        filters,
        allRowsSelected,
        handleSetFilters,
        refreshTable
        //selectAllRows
    }){
        const ids = []
        for(let data of selectedRows){
            ids.push(''+data.id)
        }
            return (
              <>
                <ApolloConsumer>
                    {client => (
                        <MenuItem onClick={() => this.validateHandler({selectedRows: ids, filters: filters, allRowsSelected: allRowsSelected, closePopper, clearAllSelections, handleSetFilters, client, refreshTable})}>
                            <ListItemIcon>
                                <ThumbUpIcon />
                            </ListItemIcon>
                            <ListItemText primary={t("tableFooter: Validate Selected Inventories")}/>
                        </MenuItem>
                    )}
                </ApolloConsumer>

                <ClearSelectedCheckboxesMenuItem 
                    closePopper={closePopper} 
                    clearAllSelections={clearAllSelections}
                    t={t}
                />
              </>
            )

    }
}

function PeriodSelectComponent(props){
    const { closePopper,
            clearAllSelections,
            ListItemIcon,
            ListItemText,
            MenuItem,
            t,
            selectedRows,
            filters,
            allRowsSelected,
            handleMessage,
            handleErrorMessage,
            refreshTable,
            tableCount,
            openDialogFunction
        } = props

    return (
        <>
            <ClearSelectedCheckboxesMenuItem 
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />
            <MenuItem 
                key={'mnu_item_process'}
                onClick={
                    () => {
                        openDialogFunction('Publish');
                        closePopper();
                    }
                }
            >
                <ListItemIcon>
                    <DoneIcon />
                </ListItemIcon>
                <ListItemText primary={t("tableFooter:Publish Selected Periods")} />
            </MenuItem>
            <MenuItem 
                key={'mnu_item_clear'}
                onClick={
                    () => {
                        openDialogFunction('UnPublish');
                        closePopper();
                    }
                }
            >
                <ListItemIcon>
                    <ClearIcon />
                </ListItemIcon>
                <ListItemText primary={t("tableFooter:UnPublish Selected Periods")} />
            </MenuItem>
        </>
    )
}

class PeriodSelectedActions extends BaseSelectedRowsActionsStrategy {
  constructor(openDialogFunction) {
    super();
    this.openDialogFunction = openDialogFunction;
  }

  doFor({
    closePopper,
    changeSelectedState,
    clearAllSelections,
    ListItemIcon,
    ListItemText,
    MenuItem,
    t,
    selectedRows,
    allRowsSelected,
    filters,
    handleSetFilters,
    handleErrorMessage,
    handleMessage,
        refreshTable
    }){
        return (
            <PeriodSelectComponent
                closePopper={closePopper}
                clearAllSelections={clearAllSelections}
                ListItemIcon={ListItemIcon}
                ListItemText={ListItemText}
                MenuItem={MenuItem}
                t={t}
                selectedRows={selectedRows}
                allRowsSelected={allRowsSelected}
                filters={filters}
                handleErrorMessage={handleErrorMessage}
                handleMessage={handleMessage}
                refreshTable={refreshTable}
                openDialogFunction={this.openDialogFunction}
            />
        )
    }
}

function WebCredentialSelectComponent(props){
    const client = useApolloClient()
    const [open, setOpen] = useState(false)

    const { changeSelectedState,
            closePopper,
            clearAllSelections,
            ListItemIcon,
            ListItemText,
            MenuItem,
            t,
            selectedRows,
            filters,
            allRowsSelected,
            handleMessage,
            handleErrorMessage,
            refreshTable,
            mutation,
            tableCount
    } = props

    const mutateSelectedWebCredentials =(props)=>{
        let ids = []
        for(let data of props.selectedRows){
            ids.push(data.id)
        }

        client.mutate({
            mutation: props.mutation,
            variables : {ids : ids, allRecords: allRowsSelected, filters: JSON.stringify(filters), phisicalDelete:true}
        }).then(
            res => {
                handleMessage('Web Credentials deleted successfully');
                refreshTable();
                closePopper();
            }
        ).catch(
            err =>{
                handleErrorMessage(String(err));
            }
        )

    }

    const handleAction = () =>{
        closePopper();
        clearAllSelections();
        mutateSelectedWebCredentials(
            {
                selectedRows: selectedRows, 
                mutation: mutation, 
                closePopper: closePopper, 
                clearAllSelections: clearAllSelections
            }
        )
    }

    const isDisabled = () => {
        return !(tableCount == 1 || selectedRows.length == 1)
    }

    return (
        <>
            <ToggleSelectedStatusMenuItem 
                changeSelectedState={changeSelectedState}
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />

            <MenuItem key={'mnu_item_delete'} disabled={isDisabled()} onClick={() => {setOpen(true)}}>
                <ListItemIcon>
                    <DeleteIcon />
                </ListItemIcon>
                <ListItemText primary={t("tableFooter: Delete Selected Web Credentials")} />
            </MenuItem>

            <ClearSelectedCheckboxesMenuItem 
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />

            <BPMDialog
                key='dlg_delete'
                open={open}
                onClose={() => {setOpen(false)}}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogTitle id='alert-dialog-title'>
                    {t('Delete Web Credentials')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        <a style={{ fontWeight: "bold", color:'#b20e0e' }}>{t('tableFooter:This action will perform a physical delete on the Web Credentials table')}</a>
                        <br></br>
                        <br></br>
                        {t('tableFooter:Confirm deleting selected Web Credentials')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button key='ftr_btn_a' onClick={() => {setOpen(false)}} variant='contained'>{t('tableFooter:Cancel')}</Button>
                    <Button key='ftr_btn_b' 
                        onClick={() => {handleAction()}}
                        variant='contained' 
                        color='secondary'  
                        autoFocus
                    >
                        {t('tableFooter:Confirm')} 
                    </Button>
                </DialogActions>
            </BPMDialog>
        </>
    )

}

class WebCredentialSelectedActions extends BaseSelectedRowsActionsStrategy {
  constructor(mutation) {
    super();
    this.mutation = mutation;
  }

    doFor({
        closePopper,
        changeSelectedState,
        clearAllSelections,
        ListItemIcon,
        ListItemText,
        MenuItem,
        t,
        selectedRows,
        allRowsSelected,
        filters,
        handleSetFilters,
        handleErrorMessage,
        handleMessage,
        refreshTable,
        tableCount
    }){
        return (
            <WebCredentialSelectComponent
                changeSelectedState={changeSelectedState}
                closePopper={closePopper}
                clearAllSelections={clearAllSelections}
                ListItemIcon={ListItemIcon}
                ListItemText={ListItemText}
                MenuItem={MenuItem}
                t={t}
                selectedRows={selectedRows}
                allRowsSelected={allRowsSelected}
                filters={filters}
                handleErrorMessage={handleErrorMessage}
                handleMessage={handleMessage}
                refreshTable={refreshTable}
                mutation={this.mutation}
                tableCount={tableCount}
            />
        )
    }
}

function DeleteSelectBudgetsComponent(props){
    const client = useApolloClient()
    const [open, setOpen] = useState(false)

    const { changeSelectedState,
            closePopper,
            clearAllSelections,
            ListItemIcon,
            ListItemText,
            MenuItem,
            t,
            selectedRows,
            filters,
            allRowsSelected,
            handleMessage,
            handleErrorMessage,
            refreshTable,
            mutation,
    } = props

    const mutateSelectedelements =(props)=>{
        let ids = []
        for(let data of props.selectedRows){
            ids.push(data.id)
        }

        client.mutate({
            mutation: props.mutation,
            variables : {ids : ids, allRecords: allRowsSelected, filters: JSON.stringify(filters)}
        }).then(
            res => {
                handleMessage('Selected Budgets deleted successfully');
                refreshTable();
                closePopper();
            }
        ).catch(
            err =>{
                handleErrorMessage(String(err));
            }
        )

    }

    const handleAction = () =>{
        closePopper();
        clearAllSelections();
        mutateSelectedelements(
            {
                selectedRows: selectedRows, 
                mutation: mutation, 
                closePopper: closePopper, 
                clearAllSelections: clearAllSelections
            }
        )
    }

    return (
        <>
            <MenuItem key={'mnu_item_delete'} onClick={() => {setOpen(true)}}>
                <ListItemIcon>
                    <DeleteIcon />
                </ListItemIcon>
                <ListItemText primary={t("tableFooter: Delete Selected Budgets")} />
            </MenuItem>

            <ClearSelectedCheckboxesMenuItem 
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />

            <BPMDialog
                key='dlg_delete'
                open={open}
                onClose={() => {setOpen(false)}}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogTitle id='alert-dialog-title'>
                    {t('Delete Budgets')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        <a style={{ fontWeight: "bold", color:'#b20e0e' }}>{t('tableFooter:This action will perform a physical delete on the Budgets table')}</a>
                        <br></br>
                        <br></br>
                        {t('tableFooter:Confirm deleting selected Budgets')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button key='ftr_btn_a' onClick={() => {setOpen(false)}} variant='contained'>{t('tableFooter:Cancel')}</Button>
                    <Button key='ftr_btn_b' 
                        onClick={() => {handleAction()}}
                        variant='contained' 
                        color='secondary'  
                        autoFocus
                    >
                        {t('tableFooter:Confirm')} 
                    </Button>
                </DialogActions>
            </BPMDialog>
        </>
    )
}

class DeleteSelectBudgetsActions{
    constructor(mutation){
        this.mutation = mutation;
    }

    doFor({
        closePopper,
        changeSelectedState,
        clearAllSelections,
        ListItemIcon,
        ListItemText,
        MenuItem,
        t,
        selectedRows,
        allRowsSelected,
        filters,
        handleSetFilters,
        handleErrorMessage,
        handleMessage,
        refreshTable,
        tableCount
    }){
        return (
            <DeleteSelectBudgetsComponent
                changeSelectedState={changeSelectedState}
                closePopper={closePopper}
                clearAllSelections={clearAllSelections}
                ListItemIcon={ListItemIcon}
                ListItemText={ListItemText}
                MenuItem={MenuItem}
                t={t}
                selectedRows={selectedRows}
                allRowsSelected={allRowsSelected}
                filters={filters}
                handleErrorMessage={handleErrorMessage}
                handleMessage={handleMessage}
                refreshTable={refreshTable}
                mutation={this.mutation}
                tableCount={tableCount}
            />
        )
    }
}


function CMFileSelectComponent(props){
    const client = useApolloClient()

    const { closePopper,
            clearAllSelections,
            ListItemIcon,
            ListItemText,
            MenuItem,
            t,
            selectedRows,
            filters,
            allRowsSelected,
            handleMessage,
            handleErrorMessage,
            refreshTable
         } = props

    const ROLLBACK_CM_FILE_PROCESSOR = gql `
        mutation($companyChangeId: String!) {
            companyChangeRollBack(companyChangeId: $companyChangeId) {
                response
            }
        }
    `;
         
    const mutateSelectedCMFiles =(props)=>{
        let id = null
        for(let data of props.selectedRows){
            id = data.id
        }

        client.mutate({
            mutation: props.mutation,
            variables : {companyChangeId : id}
        }).then(
            res => {
                handleMessage('Done');
                refreshTable();
                closePopper();
            }
        ).catch(
            err => {
                handleErrorMessage(String(err));
            }
        )

    }

    const handleAction = (mutation) =>{
        closePopper();
        clearAllSelections();
        mutateSelectedCMFiles({
            selectedRows: selectedRows,
            mutation: mutation,
            closePopper: closePopper, 
            clearAllSelections: clearAllSelections
        })
    }

    const optionIsEnabled = () =>{
        return allRowsSelected ? false : selectedRows.length == 1 && selectedRows[0].canBeRollBacked == "true"
    }

    return (
        <>
            <ClearSelectedCheckboxesMenuItem 
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />
            {optionIsEnabled() ? <MenuItem key={'mnu_item_unpublish'} onClick={() => {handleAction(ROLLBACK_CM_FILE_PROCESSOR)}}>
                <ListItemIcon>
                    <ClearIcon />
                </ListItemIcon>
                <ListItemText primary={t("tableFooter: Rollback Selected Integration File")} />
            </MenuItem>
            : null}
        </>
    )

}


class CMFileSelectedSelectedActions{
    doFor({
        closePopper,
        changeSelectedState,
        clearAllSelections,
        ListItemIcon,
        ListItemText,
        MenuItem,
        t,
        selectedRows,
        allRowsSelected,
        filters,
        handleSetFilters,
        handleErrorMessage,
        handleMessage,
        refreshTable
    }){
        return (
            <CMFileSelectComponent
                changeSelectedState={changeSelectedState}
                closePopper={closePopper}
                clearAllSelections={clearAllSelections}
                ListItemIcon={ListItemIcon}
                ListItemText={ListItemText}
                MenuItem={MenuItem}
                t={t}
                selectedRows={selectedRows}
                allRowsSelected={allRowsSelected}
                filters={filters}
                handleErrorMessage={handleErrorMessage}
                handleMessage={handleMessage}
                refreshTable={refreshTable}
            />
        )
    }
}


function BayphoneSelectComponent(props) {
    const { closePopper,
            clearAllSelections,
            ListItemIcon,
            ListItemText,
            MenuItem,
            t,
            allRowsSelected,
            tableCount,
            selectedRows,
            openActivateDialogFunction,
            openResendMailDialogFunction,
            openReimbursedDialogFunction,
            openHoldDialogFunction,
            openUnHoldDialogFunction,
            openCloseDialogFunction,
        } = props

    const canExecuteAction = () => {
        return (!allRowsSelected) && (selectedRows.length === 1);
    }

    return (
        <>
            <ClearSelectedCheckboxesMenuItem 
                closePopper={closePopper} 
                clearAllSelections={clearAllSelections}
                t={t}
            />
            { (canExecuteAction()) && selectedRows[0].stateIdentifier == "planned" ? (
                <MenuItem 
                    key={'activate'}
                    onClick={
                        () => {
                            openActivateDialogFunction();
                            closePopper();
                        }
                    }
                >
                    <ListItemIcon>
                        <ArrowForwardIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("tableFooter:Activate")} />
                </MenuItem>
            ) : null }
            { (canExecuteAction()) && selectedRows[0].stateIdentifier == "pending" ? (
                <MenuItem 
                    key={'resend_mail'}
                    onClick={
                        () => {
                            openResendMailDialogFunction();
                            closePopper();
                        }
                    }
                >
                    <ListItemIcon>
                        <MailIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("tableFooter:Resend mail")} />
                </MenuItem>
            ) : null }
             { (canExecuteAction()) && selectedRows[0].stateIdentifier == "signed"? (
                <MenuItem 
                    key={'reimbursed'}
                    onClick={
                        () => {
                            openReimbursedDialogFunction();
                            closePopper();
                        }
                    }
                >
                    <ListItemIcon>
                        <DoneIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("tableFooter:Reimbursed")} />
                </MenuItem>
            ) : null }
            { (canExecuteAction()) && !["closed", "on hold"].includes(selectedRows[0].stateIdentifier) ? (
                <MenuItem 
                    key={'hold'}
                    onClick={
                        () => {
                            openHoldDialogFunction();
                            closePopper();
                        }
                    }
                >
                    <ListItemIcon>
                        <ScheduleOutlined />
                    </ListItemIcon>
                    <ListItemText primary={t("tableFooter:Hold")} />
                </MenuItem>
            ) : null }
            { (canExecuteAction()) && selectedRows[0].stateIdentifier == "on hold" ? (
                <MenuItem 
                    key={'un_hold'}
                    onClick={
                        () => {
                            openUnHoldDialogFunction();
                            closePopper();
                        }
                    }
                >
                    <ListItemIcon>
                        <UpdateOutlined />
                    </ListItemIcon>
                    <ListItemText primary={t("tableFooter:UnHold")} />
                </MenuItem>
            ) : null }
            { (canExecuteAction()) && selectedRows[0].stateIdentifier != "closed" ? (
                <MenuItem 
                    key={'close'}
                    onClick={
                        () => {
                            openCloseDialogFunction();
                            closePopper();
                        }
                    }
                >
                    <ListItemIcon>
                        <UpdateOutlined />
                    </ListItemIcon>
                    <ListItemText primary={t("tableFooter:Close")} />
                </MenuItem>
            ) : null }
        </>
    )
}

class BayphoneSelectedActions extends BaseSelectedRowsActionsStrategy {
    constructor(openActivateDialogFunction, openResendMailDialogFunction, openReimbursedDialogFunction, openHoldDialogFunction, openUnHoldDialogFunction, openCloseDialogFunction){
    super();
    this.openActivateDialogFunction = openActivateDialogFunction;
        this.openResendMailDialogFunction = openResendMailDialogFunction
        this.openReimbursedDialogFunction = openReimbursedDialogFunction;
        this.openHoldDialogFunction = openHoldDialogFunction;
        this.openUnHoldDialogFunction = openUnHoldDialogFunction;
        this.openCloseDialogFunction = openCloseDialogFunction;
    }

    doFor({
        closePopper,
        clearAllSelections,
        ListItemIcon,
        ListItemText,
        MenuItem,
        t,
        selectedRows,
        allRowsSelected,
        filters,
        handleErrorMessage,
        handleMessage,
        refreshTable,
        tableCount
    }){
        return (
            <BayphoneSelectComponent
                closePopper={closePopper}
                clearAllSelections={clearAllSelections}
                ListItemIcon={ListItemIcon}
                ListItemText={ListItemText}
                MenuItem={MenuItem}
                t={t}
                selectedRows={selectedRows}
                allRowsSelected={allRowsSelected}
                filters={filters}
                handleErrorMessage={handleErrorMessage}
                handleMessage={handleMessage}
                refreshTable={refreshTable}
                openActivateDialogFunction={this.openActivateDialogFunction}
                openResendMailDialogFunction={this.openResendMailDialogFunction}
                openReimbursedDialogFunction={this.openReimbursedDialogFunction}
                openHoldDialogFunction={this.openHoldDialogFunction}
                openUnHoldDialogFunction={this.openUnHoldDialogFunction}
                openCloseDialogFunction={this.openCloseDialogFunction}
                tableCount={tableCount}
            />
        )
    }
}

const excelComaSeparator= (data,mapper) => {
    //data parameter must an array
    let mappedData = ""
    for(let individualData of data){
        individualData = individualData == data[0] ? individualData[mapper] : `, ${individualData[mapper]}`
        mappedData = mappedData + individualData
    }
    return mappedData
}

export {
    TableMapperCreator,
    TableFieldDescription,
    DataTransformer,
    TablePickerClickStrategy,
    DefaultClickStrategy,
    InventoryClickStrategy,
    TablePickerDisplayStrategy,
    TableMultiPickerDisplayStrategy,
    MassiveUploadsDisplayStrategy,
    FormSection,
    TableColumSection,
    InvoiceDisplayStrategy,
    CustomPopUpContentDisplayStrategy,
    customFormConfirmStrategy,
    customFormCancelStrategy,
    FormCreator,
    FormFieldDescription,
    TableCreator,
    DataMapper,
    InvoiceClickStrategy,
    HideDeletionDisplayStrategy,
    SimpleTableDisplayStrategy,
    ProcessControlSubProcessesDisplayStrategy,
    OnlyFilterActionDisplayStrategy,
    ValidateSelectedInventoriesStrategy,
    InventoryValidationDisplayStrategy,
    HideMassiveUploadsDisplayStrategy,
    CustomTableRowMapperDataGetter,
    NullClickStrategy,
    NumberComponentCreator,
    BudgetPeriodComponentCreator,
    NumberComponent,
    NumberIconedComponentCreator,
    NumberLinkIconComponentCreator,
    NumberIconedComponent,
    PasswordComponentCreator,
    StateComponentCreator,
    PasswordComponent,
    ThousandSeparatorCreator,
    ProcessControlTasksComponentCreator,
    StatusComponentCreator,
    HideEditButtonDisplayStrategy,
    CustomChip,
    InvoiceSelectedActions,
    PeriodSelectedActions,
    GeneralChipComponentCreator,
    StatusChipComponentCreator,
    CMActionChipComponentCreator,
    PeriodSubProcessStateChipComponentCreator,
    excelComaSeparator,
    BooleanExcelDisplayCreator,
    ManagerExcelDisplayCreator,
    StateExcelDisplayCreator,
    GeneralExcelDisplayCreator,
    DateTimeDisplayCreator,
    DateDisplayCreator,
    TreeNodeComponentCreator,
    DefaultComponentCreator,
    DefaultComponent,
    DateTimeComponentCreator,
    DateComponentCreator,
    InvoicePaymentGroupClickStrategy,
    ConsolidatedSBOChipComponentCreator,
    TablePickerModelClikStrategy,
    TableMultiPickerClickStrategy,
    HideNewDisplayStrategy,
    RankingDisplayStrategy,
    BusgetsDisplayStrategy,
    HideCrudDisplayStrategy,
    BaseDisplayStrategy,
    ClearSelectedCheckboxesMenuItem,
    WebCredentialSelectedActions,
    DeleteSelectBudgetsActions,
    CMFileSelectedSelectedActions,
    BayphoneSelectedActions,
    BayphoneEditButtonStrategy,
    MultilineComponentCreator,
    BaseSelectedRowsActionsStrategy,
    BaseRowActionButtonCreator,
}
